export const BASE_IMPORT_DATA = {
    TRANSLATIONS: {
        dataName: "Translations",
        codeColumnName: "Key",
        columnNames: ["Key", `en`], // EN UK
        columns: ["en-us", "de", "fr", "es", "it", "pt", "pl", "nl", "el", "tr", "sv", "ro"],
    },
};